import loadable from '@loadable/component';
import { NO_SSR } from 'shared/constants/loadable';

export const NewbuildingBrokerFlatCallbackModalContainerLoadable = loadable(
  () =>
    import('./NewbuildingBrokerFlatCallbackModalContainer').catch(
      /* istanbul ignore next */ () => ({ NewbuildingBrokerFlatCallbackModalContainer: () => null }),
    ),
  {
    resolveComponent: ({ NewbuildingBrokerFlatCallbackModalContainer }) => NewbuildingBrokerFlatCallbackModalContainer,
    ssr: NO_SSR,
  },
);
